import React from 'react';
import { Link } from 'react-router-dom';
import { Note, Steps, Crumbs, WqTable } from './wq';
import { API_KEY_STEPS, API_KEYS_PATH, KEY_MODES, MERCHANT_ID_LOCATION } from './apiKeys';

/**
 * Short "Get your API keys" section for the Web and Mobile integration pages.
 * The full guide (regenerating keys, public key, going live) is on /api-encryption.
 */
function ApiKeyGuide({ id }) {
    return (
        <section className="wq-section" id={id}>
            <h2 className="wq-h2">Get your API keys</h2>
            <p className="wq-lead">
                Every plugin and SDK on this page needs two things from your merchant dashboard: your{' '}
                <strong>Merchant ID</strong> (starts with <code>MER_</code>) and your <strong>Secret Key</strong>{' '}
                (starts with <code>WAYASECK_</code>). It takes about a minute.
            </p>

            <h4 className="wq-h4">Merchant ID</h4>
            <p className="wq-p">Your Merchant ID is shown {MERCHANT_ID_LOCATION}. Copy it from there.</p>

            <h4 className="wq-h4">Secret key</h4>
            <Crumbs items={API_KEYS_PATH} />

            <Steps items={API_KEY_STEPS} />

            <h4 className="wq-h4">Test and live keys</h4>
            <p className="wq-p">
                The key you generate matches the mode your dashboard is in. Switch between them with the{' '}
                <strong>Test / Live</strong> toggle at the top of the dashboard, then generate a key for that mode.
            </p>
            <WqTable columns={KEY_MODES.columns} rows={KEY_MODES.rows} />

            <Note label="Keep it secret">
                Treat your secret key like a password. Store it in environment variables or a secret manager — never in
                source control, a public web page or a shared document. If a key is ever exposed, generate a new one
                and update your integration.
            </Note>

            <p className="wq-p">
                Can't see the API Keys tab? Ask the account owner to give your team account access. For regenerating
                keys and going live, see the{' '}
                <Link to="/api-encryption" className="wq-link">
                    API Key Guide
                </Link>
                .
            </p>
        </section>
    );
}

export default ApiKeyGuide;